import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { CardTitle } from 'material-ui/Card'
import { setSnackbarMessage } from '../../../actions/snackbar'
import LockIcon from 'material-ui/svg-icons/action/lock'
import EmailIcon from 'material-ui/svg-icons/action/description'
import Actions from './actions'

import {
  Dialog,
  FlatButton,
  RaisedButton
} from 'material-ui'

import api from '../../../api'

class Action extends Component<any, any> {
  componentWillMount () {
    this.getResource()
  }

  constructor (props) {
    super(props)
    this.state = {
      resource: {},
      errors: {},
      showResetPassword: false,
      showResendConfirmation: false,
      resourceFiles: {},
      resetPasswordSource: null
    }
  }

  getResource () {
    const options = {
      ...this.props.options
    }

    const path = this.props.apiPath
    return api
      .get(path, options)
      .then(res => {
        if (res.status === 200) {
          res.json().then(resource => {
            this.setState({ resource })
          })
        } else {
          this.props.onSnackbarMessage('Not found')
          browserHistory.push(this.props.successRedirectPath)
        }
      })
  }

  handleResetPasswordOpen (source) {
    this.setState({
      showResetPassword: true,
      resetPasswordSource: source
    })
  }

  handleResetPasswordClose () {
    this.setState({
      showResetPassword: false,
      resetPasswordSource: null
    })
  }

  handleResetPasswordConfirm (e) {
    api
      .post(this.props.apiPath + '/password/new', { body: { source: this.state.resetPasswordSource } })
      .then(res => {
        if (res.status === 200) {
          this.props.onSnackbarMessage(`Successfully sent password reset email to User #${this.state.resource.id}`)
          browserHistory.push(this.props.successRedirectPath)
        } else {
          this.props.onSnackbarMessage(`Error sending password reset email to User #${this.state.resource.id}`)
        }
      })
    this.handleResetPasswordClose()
  }

  handleResendConfirmationOpen () {
    this.setState({
      showResendConfirmation: true
    })
  }

  handleResendConfirmationClose () {
    this.setState({
      showResendConfirmation: false
    })
  }

  handleResendConfirmationConfirm (e) {
    api
      .post(this.props.apiPath + '/confirm_email/send')
      .then(res => {
        if (res.status === 200) {
          this.props.onSnackbarMessage(`Successfully sent confirmation email to User #${this.state.resource.id}`)
          browserHistory.push(this.props.successRedirectPath)
        } else {
          this.props.onSnackbarMessage(`Error sending confirmation email to User #${this.state.resource.id}`)
        }
      })
    this.handleResendConfirmationClose()
  }

  handleMoreMenuOpen (e) {
    e.preventDefault()

    this.setState({
      moreMenuOpen: true,
      moreAnchorEl: e.currentTarget
    })
  }

  handleMoreMenuClose () {
    this.setState({
      moreMenuOpen: false
    })
  }

  handleMoreMenuItemTouchTap (e, obj) {
    if (obj.props.value) {
      browserHistory.push(obj.props.value)
    }
  }

  render () {
    const buttonStyle = {
      margin: '1em 1em 0 0'
    }

    const resetPasswordActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleResetPasswordClose.bind(this)}
      />,
      <FlatButton
        label='Send Password Reset Email'
        primary
        keyboardFocused
        onClick={this.handleResetPasswordConfirm.bind(this)}
      />
    ]

    const resendConfirmationActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleResendConfirmationClose.bind(this)}
      />,
      <FlatButton
        label='Send Confirmation Email'
        primary
        keyboardFocused
        onClick={this.handleResendConfirmationConfirm.bind(this)}
      />
    ]

    return (
      <div>
        <Actions
          resource={this.state.resource}
          successRedirectPath={this.props.successRedirectPath}
          buildMenuItems={this.props.buildMenuItems}
          handleMoreMenuOpen={this.handleMoreMenuOpen.bind(this)}
          handleMoreMenuClose={this.handleMoreMenuClose.bind(this)}
          handleMoreMenuItemTouchTap={this.handleMoreMenuItemTouchTap.bind(this)}
          moreMenuOpen={this.state.moreMenuOpen}
          moreAnchorEl={this.state.moreAnchorEl}
        />
        <form>
          <CardTitle title={`${this.props.title} #${this.state.resource.id}`} style={{ paddingLeft: 0 }} />
          <RaisedButton
            label='Re-send confirmation email'
            primary
            onClick={this.handleResendConfirmationOpen.bind(this)}
            icon={<EmailIcon />}
            style={buttonStyle}
          />
          <RaisedButton
            label='Reset NCFDD password'
            primary
            onClick={() => this.handleResetPasswordOpen.bind(this)('ncfdd')}
            icon={<LockIcon />}
            style={buttonStyle}
          />
          <RaisedButton
            label='Reset WriteNow password'
            primary
            onClick={() => this.handleResetPasswordOpen.bind(this)()}
            icon={<LockIcon />}
            style={buttonStyle}
          />
        </form>

        <Dialog
          title='Confirm Password Reset'
          actions={resetPasswordActions}
          modal={false}
          open={this.state.showResetPassword}
          onRequestClose={this.handleResetPasswordClose.bind(this)}
        >
          Are you sure you want to send a password reset email?
        </Dialog>

        <Dialog
          title='Confirm sending a confirmation email'
          actions={resendConfirmationActions}
          modal={false}
          open={this.state.showResendConfirmation}
          onRequestClose={this.handleResendConfirmationClose.bind(this)}
        >
          Are you sure you want to re-send a confirmation email?
        </Dialog>
      </div>
    )
  }
}

// @ts-ignore
Action.propTypes = {
  apiPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  successRedirectPath: PropTypes.string.isRequired,
  onSnackbarMessage: PropTypes.func.isRequired,
  disableDelete: PropTypes.bool,
  options: PropTypes.object
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onSnackbarMessage: (msg) => {
    dispatch(setSnackbarMessage(msg))
  }
})

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(Action)
